import * as yup from "yup";

let activationFormValidation = yup.object().shape({
    warrantyNo: yup.string().min(6, "Too Short!-should be 6 chars minimum").required("Required"),
    serialNo: yup.string().min(6, "Too Short!-should be 6 chars minimum").required("Required"),
    name: yup.string().min(3, "Too Short!-should be 3 chars minimum").required("Required"),
    email: yup.string().email("Invalid email").required("Required"),

    //   password: yup
    //     .string()
    //     .min(6, "Too Short! - should be 6 chars minimum.")
    //     .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    //     .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    //     .matches(/[0-9]/, "Password must contain a number.")
    //     .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    //     .required("Required"),

});
let lookUpValidation = yup.object().shape({
    warrantyNumber: yup.string().min(6, "Too Short!-should be 6 chars minimum"),
    serialNumber: yup.string().min(6, "Too Short!-should be 6 chars minimum"),
});
export { activationFormValidation, lookUpValidation };